import { PaneArea } from '../../types/shared'
import XABCD, { IXABCDAttrs, IXABCDPositionAttrs } from '../canvas/xabcd'
import PaneModel from '../models/pane'

type Area = PaneArea
type Attrs = IXABCDAttrs
type PartialAttrs = Partial<Attrs>

class XABCDCreator extends XABCD<Attrs> {
  isCreator = true
  mouseDowns = 1

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    this.attrs.xx = startArea.x
    this.attrs.xy = startArea.y
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseDown() {
    this.mouseDowns++
    if (this.mouseDowns === 5) {
      this.release()
      this.replaceMyself(XABCD.fromObject<XABCD>(this.attrs, this.model))
      this.toolsCallback()
    }
  }

  onMouseMove(area: Area) {
    const types = 'xabcd'
    const typeX = (types[this.mouseDowns] + 'x') as keyof IXABCDPositionAttrs
    const typeY = (types[this.mouseDowns] + 'y') as keyof IXABCDPositionAttrs
    this.attrs[typeX] = area.x
    this.attrs[typeY] = area.y
    this.trigger('change')
  }
}

export default XABCDCreator
